




































import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import * as types from '@/store/account/types'
import * as mainTypes from '@/store/content/types'
import VButton from '@/components/VButton.vue'
import VModal from '@/components/VModal.vue'
import VContentList from '@/components/VContentList.vue'
import Content from '@/store/models/content'
import ChangeGradeModal from './ChangeGradeModal.vue'

@Component({ components: { VButton, VContentList, VModal, ChangeGradeModal } })
export default class LearnHome extends Vue {
  @Getter('userInfo', { namespace: 'account' }) getUserInfo!: types.AccountState
  @Action('userInfo', { namespace: 'account' }) private loadUserInfo!: types.UserInfoAction
  @Action('favorites', { namespace: 'account' }) private loadFavorites!: types.FavoritesAction
  @Action('recommendedContent', { namespace: 'content' }) private loadRecommendedContent!: mainTypes.RecommendedContentAction

  private showModal = false
  private recommendedContent: Content[] = []

  private created () {
    this.loadUserInfo()
    this.loadFavorites()
    this.loadRecommendedContent().then((response) => {
      this.recommendedContent = response
    })
  }
}
